var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_48_380",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_48_380",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAAB10lEQVRYhe1WO27CQBB9EIqUlCkjnyA5ASBNHyjTwQmSnCCkTAUpUyWcAFJGGgnTpQsnQBzBR4jGGpNlvYu9jmkinmRZ3h3vvJ339oMT/iWI6LLsvBp1FYCIugDuAPSN5gTAC4ApMyf4JTdk5vEeAe1YAhgw8zow+RDA24EQSf4EoKMEY2buSUfTCJKOlAQRXQUk7xckF7QBTDSHkHnIcjStoOy91IHLYFKWrGKrle7bBGzGcyKaHzKU6l7acAqZ+TrzgEkgcQQLy28imniIdAOTCxbis+yjZXW4yinVuJeHiMScMzVRkFEzMPPA/N5bhlJyaxkVITG8UwZS+mszbicBEcksVx4pfAhJDtfYpgQy2GPggH+GacJKmgZiZYfvCDDzQtfoMZGbpL0PjI5MID5IgJkloBdoxLJYZAeSl4CirXtC3XLMXI0tR5voNK85+VY9lkOuAswsM5/WTMDrrTNX42az+YyiqFFxr7chl5HXIAJKIo6iKNPtHMBFheRre++34TuOU6gcHxUSQ73UKwpy3gn1nL8xbkmhEMONXMvOSYCIxjWdA+l1i5nfy/6QesDQu603liqJnwHcMvNXyI85CYioraXvKBkfoVh1XvnW+AknFALADyUbkdNh7rN9AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b66d9d65bea9be533cdb4b6b93c53ec7.svg";
export { ForwardRef as ReactComponent };